import type {
  CollectedFact,
  ExtractedInsight,
} from "@/services/assistant-service";

export interface InsightField {
  key: string;
  label: string;
  value: string;
}

// The same collected facts populate Insight Extraction and the editable inquiry
// draft. Missing fields have no placeholder row; explicit unknown answers do.
export function insightFields(
  insight?: ExtractedInsight,
  interests: { id: string; name: string }[] = [],
  summarized = false,
): InsightField[] {
  const rows: InsightField[] = [];
  const add = (key: string, label: string, value?: string, unknown = false) => {
    if (value?.trim())
      rows.push({
        key,
        label,
        value:
          (summarized ? insight?.summaries?.[key] || value : value) +
          (unknown ? " (미확인)" : ""),
      });
  };
  const fact = (key: string, label: string, value?: CollectedFact) =>
    add(key, label, value?.quote, value?.status === "unknown");
  if (insight) {
    add(
      "company",
      "기업 세그먼트",
      insight.company_size,
      insight.company_size_status === "unknown",
    );
    fact("industry", "산업 분류", insight.industry);
    insight.needs.forEach((need, index) => {
      const prefix = insight.needs.length > 1 ? `업무 ${index + 1} · ` : "";
      for (const [key, label, value] of [
        ["work", "업무 영역", need.work],
        ["needs", "니즈 정의", need.needs],
        ["bottleneck", "병목 단계·원인", need.bottleneck],
        ["as-is", "현재 업무", need.as_is],
        ["goal", "기대 결과", need.goal],
      ])
        add(`${index}:${key}`, prefix + label, value);
      add(
        `${index}:systems`,
        prefix + "시스템 환경",
        need.environment.join(" · "),
        need.environment_status === "unknown",
      );
      add(`${index}:integration`, prefix + "연동 대상·방식", need.integration);
    });
    fact("deployment", "배포 환경", insight.deployment);
    fact("security", "보안·데이터 제약", insight.security);
    add("adoption-method", "도입 방식", insight.adoption_method);
    add("adoption-conditions", "도입 여건", insight.adoption_conditions);
  }
  add("interests", "관심 대상", interests.map((item) => item.name).join(" · "));
  add("unknown", "미확인 사항", insight?.unknown.join(" · "));
  return rows;
}
